var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaxDuration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.728 12.7102L15.504 16.9022C15.2907 17.0728 15.216 17.2968 15.28 17.5742C15.344 17.8515 15.5147 18.0222 15.792 18.0862C16.0693 18.1288 16.2933 18.0435 16.464 17.8302L21.808 12.5182C21.936 12.3902 22 12.2302 22 12.0382C22 11.8462 21.936 11.6862 21.808 11.5582L16.464 6.21416C16.336 6.08616 16.176 6.02215 15.984 6.02215C15.792 6.02215 15.632 6.08616 15.504 6.21416C15.376 6.34216 15.312 6.50216 15.312 6.69416C15.312 6.88616 15.376 7.04615 15.504 7.17415L19.728 11.3662H4.272L8.464 7.17415C8.67733 7.00348 8.752 6.77949 8.688 6.50216C8.624 6.22483 8.45333 6.06482 8.176 6.02215C7.89867 5.95815 7.67467 6.03283 7.504 6.24616L2.192 11.5582C2.064 11.6862 2 11.8462 2 12.0382C2 12.2302 2.064 12.3902 2.192 12.5182L7.504 17.8622C7.632 17.9902 7.792 18.0542 7.984 18.0542C8.176 18.0542 8.336 17.9902 8.464 17.8622C8.592 17.7342 8.656 17.5742 8.656 17.3822C8.656 17.1902 8.592 17.0302 8.464 16.9022L4.272 12.7102H19.728Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxDuration);
export default __webpack_public_path__ + "static/media/MaxDuration.3e7f5df32707206ecac997364b4d76bd.svg";
export { ForwardRef as ReactComponent };